module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_normal.1001.564046ce.jpg";